import cn from 'classnames'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'
import { useMemo } from 'react'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { getDivisor } from '../../../../helpers/getDivisor'
import { getFractionDigits } from '../../../../helpers/getFractionDigits'
import { actualsColor, quotaColor, targetsColor } from '../../config'
import styles from '../../RetailFinSob.module.scss'

interface IProps {
  fieldValue: number
  fieldType?: 'targets' | 'actuals' | 'quota'
  fractionDigits?: number
  rounding?: string

  isShowZero?: boolean
  tip?: string
  percent?: boolean
}

export const ViewField = (props: IProps) => {
  const {
    fieldValue,
    fieldType = 'targets',
    fractionDigits = 0,
    rounding = '',

    isShowZero = false,
    tip = '',
    percent = false,
  } = props

  /** ------------------------- Variables ------------------------- */

  const formattedValue = useMemo(() => {
    if (!isShowZero && fieldValue === null) {
      return '-'
    }

    const roundingFractionDigits = getFractionDigits(rounding)
    const recalculatedFractionDigits =
      !fractionDigits && roundingFractionDigits ? roundingFractionDigits : fractionDigits
    const divisor = getDivisor(rounding)

    return formatMoneyInteger(fieldValue, recalculatedFractionDigits, divisor)
  }, [fieldValue, fractionDigits, isShowZero, rounding])

  const isShowPercent = useMemo(() => {
    return percent && formattedValue !== '-'
  }, [formattedValue, percent])

  const { isUseColor, color } = useMemo(() => {
    let isUseColor = false
    let color = targetsColor
    switch (fieldType) {
      case 'actuals': {
        color = actualsColor
        isUseColor = true
        break
      }
      case 'quota': {
        color = quotaColor
        isUseColor = true
        break
      }
      case 'targets':
      default: {
        // Not use custom Color
        break
      }
    }

    return { isUseColor, color }
  }, [fieldType])

  /** ------------------------- Render ------------------------- */

  return (
    <Tooltip
      inline
      tipContent={() => (
        <div className={styles.productLineTip}>
          <span>{tip}</span>
        </div>
      )}
      horizontalStartPosition={TPopupHorizontal.Center}
      horizontalDirection={TPopupHorizontal.Center}
      disabled={!tip}
    >
      {!isUseColor ? (
        <div className={cn({ [styles.valueTip]: tip })}>
          {formattedValue}
          {isShowPercent ? '%' : ''}
        </div>
      ) : (
        <div className={cn({ [styles.valueTip]: tip })} style={{ color: color }}>
          {formattedValue}
          {isShowPercent ? '%' : ''}
        </div>
      )}
    </Tooltip>
  )
}
